module.exports = __webpack_public_path__ + "media/images/icons/icons_large/59_twoglasses-e7a91603fcc2f02776a8393727da3db2.png";